module.exports = __webpack_public_path__ + "img/o2o06.a6bf323d.png";